import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, NgForm } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { ContactDetailsService } from './contact-details.service';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { ProfileComponent } from '../../profile.component';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'kt-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit {
  @ViewChild('permenantContactDetailsForm', { static: false }) permenantContactDetailsForm: NgForm;
  public editForm: any = [];
  public addressFormData: any;
  @Input('dropdownList') dropdownList: any;
  public addressDetailsData: any = [
    { addressType: 'Permanent', addressTypeCode: 10201 },
    { addressType: 'Mailing', addressTypeCode: 10202 },
    { addressType: 'Current', addressTypeCode: 10203 },
  ];
  public selectedCountryId: number;
  public isAlertVisible: boolean = false;
  public alertType: string;
  public alertIcon: string;
  public alertMsgValue: string;
  public addresssListArray: any = [];
  public matchedAddress: any = []
  constructor(private fb: FormBuilder, private contactDetaiilsService: ContactDetailsService,
    private cdr: ChangeDetectorRef, private sharedServices: SharedService,
    private profileComp: ProfileComponent, private loaderService: LoaderService,private translate: TranslateService) { }

  ngOnInit() {
    window.scroll(0, 0)
    this.getAddressFormDetails();
  }


  public getAddressFormDetails() {
    this.cdr.detectChanges();
    this.cdr.markForCheck();
    return new Promise((resolve, reject) => {
      this.contactDetaiilsService.getAddressDetails().subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            if (res.data.length > 0) {
              this.addressDetailsData = [
                { addressType: 'Permanent', addressTypeCode: 10201 },
                { addressType: 'Mailing', addressTypeCode: 10202 },
                { addressType: 'Current', addressTypeCode: 10203 },
              ];
              res.data.sort(function (obj1, obj2) {
                return obj1.addressTypeCode - obj2.addressTypeCode;
              });
              for (let i = 0; i < res.data.length; i++) {
                for (let j = 0; j < this.addressDetailsData.length; j++) {
                  if (this.addressDetailsData[j].addressTypeCode == res.data[i].addressTypeCode) {
                    this.addressDetailsData[j] = res.data[i];
                  }
                }
              }
              this.checkMatchingAddress();
              for (let i = 0; i < this.addressDetailsData.length; i++) {
                if (this.addressDetailsData[1].countryId && this.addressDetailsData[0].countryId) {
                  this.editForm[i] = false;
                } else if (this.addressDetailsData[0].countryId) {
                  this.getEditForm(1, this.addressDetailsData[1])
                } else {
                  this.getEditForm(0, this.addressDetailsData[0])
                }
              }
              this.loaderService.setValue(false);
              this.cdr.detectChanges();
              this.cdr.markForCheck();
              resolve(this.addressDetailsData);
            } else {
              this.getEditForm(0, this.addressDetailsData[0])
            }
          } else {
            this.loaderService.setValue(false);
            this.cdr.detectChanges();
          }
        },
        (err) => {
          this.loaderService.setValue(false);
          this.cdr.detectChanges();
          console.log(err)
        }
      )
    })
      .catch(function (error) {
        console.log(error)
      })
  }

  public getEditForm(index, data?) {
    this.loaderService.setValue(false);
    this.cdr.markForCheck();
    for (let i = 0; i < this.addressDetailsData.length; i++) {
      if (this.editForm[i]) {
        this.editForm[i] = false;
      }
    }
    this.editForm[index] = true;
    this.cdr.detectChanges();
    this.getCitiesByCountry(data.countryId);
    this.getPostalCodesByCity(data.cityId);
    this.addressFormData = data;
    this.cdr.detectChanges();
  }

  public cancelEdit(index) {
    this.editForm[index] = false;
  }

  public saveAddress(index, data) {
    this.markFormsTouched(this.permenantContactDetailsForm);
    if (!this.validate(this.permenantContactDetailsForm))
      return
    this.loaderService.setValue(true)
    let payload = this.constructPayload();
    if (data.countryId != 1) {
      payload.provinceId = null;
    }
    if (data.id != undefined) {
      payload['id'] = data.id;
    }
    if (data.addressTypeCode != undefined) {
      payload['addressTypeCode'] = data.addressTypeCode;
    }
    payload = [payload];
    this.saveAddressData(payload);
  }

  public saveAddressData(payload) {
    this.isAlertVisible = false;
    delete payload[0].searchCtrl
    return new Promise((resolve, reject) => {
      this.contactDetaiilsService.saveAddress(payload).subscribe(
        async (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            // this.isAlertVisible = true;
            this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.profileMessages.ADDRESS_UPDATED_SUCCESS;
            this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
            this.loaderService.setValue(false);
            this.cdr.markForCheck();
            this.sharedServices
							.openPopupDialog(
								'SUCCESS',
								HEC_CONSTANTS.MESSGAES_LIST.profileMessages.ADDRESS_UPDATED_SUCCESS,
								HEC_CONSTANTS.ERROR_TYPES.success
							)
							.then(async (res) => {
              await this.getAddressFormDetails();

							});
            resolve(res.data);
            // setTimeout(async () => {
            //   this.isAlertVisible = false;
            //   await this.getAddressFormDetails();
            //   this.cdr.detectChanges();
            // }, 2000)
          } else {
            // this.isAlertVisible = true;
            this.alertMsgValue = res.statusDescription;
            this.sharedServices
							.openPopupDialog(
								'ERROR',
								res.statusDescription,
								HEC_CONSTANTS.ERROR_TYPES.error
							)
							.then((res) => {

							});
            this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
            this.loaderService.setValue(false);
            this.cdr.markForCheck();
          }
        },
        (err) => {
          // this.isAlertVisible = true;
          this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_ERROR;
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
          this.loaderService.setValue(false);
          this.sharedServices
							.openPopupDialog(
								'ERROR',
								HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_ERROR,
								HEC_CONSTANTS.ERROR_TYPES.error
							)
							.then((res) => {

							});
          this.cdr.markForCheck();
        }
      )
    })
      .catch(function (error) {
        console.log(error)
      })
  }

  public getPermAddressForMailing(addressData, id, addressTypeCode) {
    this.loaderService.setValue(true)
    this.cdr.detectChanges();
    let payload = addressData;
    payload.id = id;
    payload.addressTypeCode = addressTypeCode;
    payload = [payload];
    this.saveAddressData(payload);

  }

  public getDistrictByCity(cityId) {
    if (cityId != undefined) {
      this.contactDetaiilsService.getDistrictsByCityId(cityId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.dropdownList.districtList = res.data;
            this.cdr.detectChanges();
          }
          else {

          }
        },
        (err) => {
        }
      )
    }
  }

  public getPostalCodesByCity(cityId) {
    this.getDistrictByCity(cityId);
    if (cityId != undefined) {
      this.contactDetaiilsService.getPostalCodeByCityId(cityId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.dropdownList.postalCodesList = res.data;
            this.cdr.detectChanges();

          }
          else {

          }
        },
        (err) => {

        }
      )
    }
  }

  public getCitiesByCountry(countryId) {
    this.selectedCountryId = countryId;
    if (countryId != undefined) {
      this.sharedServices.getCitiesByCountryId(countryId).subscribe(
        (res: HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.dropdownList.cityList = res.data;
            this.cdr.detectChanges();
          } else {

          }
        },
        (err) => {

        }
      )
    }
  }

  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }

  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }

  private constructPayload() {
    let payload = this.permenantContactDetailsForm.value;
    return payload;
  }

  private checkMatchingAddress() {
    for (let i = 0; i < this.addressDetailsData.length - 1; i++) {
      if (this.addressDetailsData[0].address == this.addressDetailsData[i + 1].address &&
        this.addressDetailsData[0].cityId == this.addressDetailsData[i + 1].cityId &&
        this.addressDetailsData[0].countryId == this.addressDetailsData[i + 1].countryId &&
        this.addressDetailsData[0].provinceId == this.addressDetailsData[i + 1].provinceId &&
        this.addressDetailsData[0].domicileName == this.addressDetailsData[i + 1].domicileName &&
        this.addressDetailsData[0].postalCodeId == this.addressDetailsData[i + 1].postalCodeId
      ) {
        this.matchedAddress[i + 1] = true
      } else {
        this.matchedAddress[i + 1] = false
      }
    }
  }

  public goNext() {
    this.profileComp.goNext();
    this.profileComp.goNext();
  }

}
